export enum ElectricityOptions {
    UNKNOWN = 0,
    HAS_ANY = 1,
}
